import {Singleton} from "@denishussar/html5-game-engine";
import {LetterModel} from "./LetterModel";

@Singleton
export class SendLetterModel {
    public letter: LetterModel = new LetterModel();

    constructor() {
    }
}
